class ResultsGridControl extends HTMLElement {
  constructor() {
    super();

    this.elements = {
      triggers: this.querySelectorAll('[data-results-grid-control-el="trigger"]'),
    }
  }

  connectedCallback() {
    this.setupEventListeners();
    this.setupKlevuReinitialization();
  }

  setupEventListeners() {
    this.elements.triggers.forEach((trigger) => {
      trigger.addEventListener('click', this.handleTriggerClick.bind(this, trigger))
    });
  }

  setupKlevuReinitialization() {
    // Ensure event and observer are only attached once
    if (this._klevuInitialized) return;
    this._klevuInitialized = true;

    if (typeof klevu !== 'undefined') {
      klevu.coreEvent.attach("klevuCatnavAndLandingBuild", {
        name: "reinitializeGridControl",
        fire: () => {
          setTimeout(() => {
            this.reinitializeElements();
          }, 300);
        }
      });

      if (!this._mutationObserver) {
        this._mutationObserver = new MutationObserver(() => {
          this.reinitializeElements();
        });

        this._mutationObserver.observe(document.body, {
          childList: true,
          subtree: true
        });
      }
    }
  }

  reinitializeElements() {
    console.log('Reinitializing ResultsGridControl elements');
    this.elements.triggers = this.querySelectorAll('[data-results-grid-control-el="trigger"]');

    this.setupEventListeners();
  }

  handleTriggerClick(trigger) {
    if (!trigger.hasAttribute('data-metafield-trigger')) {
      this.postCartAttribute(`_collection-view-${trigger.dataset.device}`, trigger.dataset.view)
    }

    const device = trigger.dataset.device;
    const col = trigger.dataset.view;
    const mql = window.matchMedia('(max-width: 48rem)');

    if (mql.matches && device === 'mobile') {
      const grid = document.querySelector('[data-mobile-grid-columns]');
      grid.setAttribute('data-mobile-grid-columns', col)
      grid.style.setProperty('--mobile-grid-columns', col)

    } else if (device === 'desktop') {
      const grid = document.querySelector('[data-desktop-grid-columns]');
      grid.setAttribute('data-desktop-grid-columns', col)
      grid.style.setProperty('--desktop-grid-columns', col)
    }

    this.elements.triggers.forEach(el => {
      if (el.dataset.device === device) {
        el.setAttribute('aria-pressed', 'false')

        if (el === trigger) {
          el.setAttribute('aria-pressed', 'true')
        }
      }
    })
  }

  async postCartAttribute (key, value) {
    try {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          attributes: {
            [key]: value,
          },
        }),
      })
      if (!response.ok) {
        throw new Error('Network response not OK')
      }
    } catch (error) {
      console.error('Failed to POST cart attribute', error)
    }
  }
}

customElements.define('results-grid-control', ResultsGridControl);